// extracted by mini-css-extract-plugin
export default {"component":"routes_component__0yJx-","darkMode":"routes_darkMode__Rolyd"};